/**
 * Superficie del bounded context Fiscal — infra y application.
 * Funciones con dependencias de infra/app (pueden generar require cycles).
 */

export {
  resolveFiscalReadiness,
  showFiscalDevEnvironmentSelector,
  type FiscalReadiness,
} from './application/fiscalReadiness';

export {
  copyFiscalComprobanteSummary,
  downloadFiscalComprobantePdf,
  type FiscalComprobanteExportInput,
  type FiscalComprobanteExportItem,
} from './application/fiscalInvoiceExport';

export {
  buildAfipQrUrl,
  buildFiscalComprobanteFilename,
  encodeBase64Utf8,
} from './application/fiscalComprobanteFormat';

export { mapSaleItemsToFiscalExport } from './application/fiscalComprobanteItems';

export {
  emitFiscalInvoiceAwaitingCae,
  type FiscalEmitAwaitOutcome,
} from './application/emitInvoiceForPrint';

export {
  handleLibroIvaExport,
  handleLibroIvaTxtExport,
} from './application/libroIvaExport';

export { consultaPadron } from './infra/padronAdapter';

export {
  getArcaIntegrationStatus,
  getFiscalContext,
  getFiscalProfile,
  invalidateFiscalContextCache,
  type ArcaIntegrationStatus,
} from './infra/fiscalConfigRepo';

export {
  exportLibroIvaVentasCsv,
  fetchLibroIvaVentasRows,
  emitFiscalDebitNote,
  fetchDebitNotesForSale,
  fetchFiscalYtdTotal,
  fetchFiscalYtdTotalOrg,
  fetchFiscalYtdTotals,
  retryFiscalInvoiceEmit,
  saveFiscalProfileRemote,
  validateArcaSetup,
  validateBranchPointOfSale,
  consultFiscalInvoiceInAfip,
  retryFiscalCreditNoteEmit,
  fetchCreditNotesForBranch,
  fetchCreditNoteForSale,
  fetchFiscalInvoiceForSale,
  updateSaleFiscalBuyerForReemit,
  type FiscalInvoiceEmitResult,
  type FiscalEmissionEmitter,
  type ValidateArcaSetupOptions,
  type SaveFiscalProfileOptions,
  type FiscalInvoiceConsultResult,
  type CreditNoteListRow,
  type FiscalInvoiceDetailRow,
  type FiscalYtdTotals,
} from './infra/fiscalRepository';

export {
  type ArcaWizardDraft,
  resolveArcaWizardStep,
  loadArcaWizardDraft,
  saveArcaWizardDraft,
  clearArcaWizardDraft,
} from './infra/arcaWizardDraftStorage';

export { persistDefaultPosFiscalMode } from './infra/posFiscalDefaultsRepo';

export {
  formatMoneyForCountry,
  resolveCountryRuntimeConfig,
  type CountryRuntimeConfig,
} from './infra/countryAdapters';

export { saveIntegrationSecrets } from '../shell/integrationSecretsRepo';
